export type BannerMode = "boost" | "boostHomepage" | "tournament";

type BannerDevice = "desktop" | "mobile";

type BannerArtwork = { bg: string; fg?: string };

type SiteBannerArtwork = Record<BannerDevice, BannerArtwork>;

// bitcasino is the required fallback; other sites are filled in as their artwork is ready.
type GamePageBannerImages = Record<
  BannerMode,
  { bitcasino: SiteBannerArtwork } & Partial<
    Record<Exclude<Site, "bitcasino">, SiteBannerArtwork>
  >
>;

const SPORTSBET_TOURNAMENT_ARTWORK: SiteBannerArtwork = {
  desktop: {
    bg: "https://heathmont.imgix.net/cms/media/SB_Boost_Desktop_ingame_600x80.jpg?q=80&auto=format%2Ccompress",
    fg: "https://heathmont.imgix.net/cms/media/Tournament%20FG.png?q=80&auto=format%2Ccompress",
  },
  mobile: {
    bg: "https://heathmont.imgix.net/cms/media/SB_Boost_Mobile_homepage_ingame_372x132.jpg?q=80&auto=format%2Ccompress",
    fg: "https://heathmont.imgix.net/cms/media/Tournament%20FG.png?q=80&auto=format%2Ccompress",
  },
};

const GAME_PAGE_BANNER_IMAGES: GamePageBannerImages = {
  boost: {
    bitcasino: {
      desktop: {
        bg: "https://heathmont.imgix.net/cms/media/BC_Boost_Desktop_homepage_default.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/v2%20boost%20fg.png?q=80&auto=format%2Ccompress",
      },
      mobile: {
        bg: "https://heathmont.imgix.net/cms/media/BC_Boost_Mobile_homepage_ingame_countdown.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Mobile.png?q=80&auto=format%2Ccompress",
      },
    },
    sportsbet: {
      desktop: {
        bg: "https://heathmont.imgix.net/cms/media/SB_Boost_Desktop_ingame_600x80.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Rocket%20boost%201.png?q=80&auto=format%2Ccompress",
      },
      mobile: {
        bg: "https://heathmont.imgix.net/cms/media/SB_Boost_Desktop_ingame_600x80.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Rocket%20boost%201.png?q=80&auto=format%2Ccompress",
      },
    },
  },
  boostHomepage: {
    bitcasino: {
      desktop: {
        bg: "https://heathmont.imgix.net/cms/media/boost-casino-bg-desktop.png?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Boost-panda-desktop.png?q=80&auto=format%2Ccompress",
      },
      mobile: {
        bg: "https://heathmont.imgix.net/cms/media/boost-casino-bg-mobile.png?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Boost-panda-mobile.png?q=80&auto=format%2Ccompress",
      },
    },
    sportsbet: SPORTSBET_TOURNAMENT_ARTWORK,
  },
  tournament: {
    bitcasino: {
      desktop: {
        bg: "https://heathmont.imgix.net/cms/media/BC_Tournament_Desktop_homepage_624x132.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Panda%20MAX%20-%20Tournament%202%203.png?q=80&auto=format%2Ccompress",
      },
      mobile: {
        bg: "https://heathmont.imgix.net/cms/media/BC_Tournament_Mobile_homepage_ingame_countdown.jpg?q=80&auto=format%2Ccompress",
        fg: "https://heathmont.imgix.net/cms/media/Mobile%20Tournament%20BC.png?q=80&auto=format%2Ccompress",
      },
    },
    sportsbet: SPORTSBET_TOURNAMENT_ARTWORK,
  },
};

export default GAME_PAGE_BANNER_IMAGES;
